<template>
  <div class="flex flex-row items-center gap-4">
    <div v-if="!loggedIn" class="flex flex-row items-center gap-4">
      <Button
        variant="light"
        size="lg"
        class="h-10 px-6 text-sm rounded-full md:h-8 md:text-sm"
        @click="openSignInModal"
      >
        <ProseSmall>
          {{ $t("auth.sign-in") }}
        </ProseSmall>
      </Button>
    </div>

    <DropdownMenu v-else>
      <DropdownMenuTrigger as-child>
        <Avatar class="w-10 h-10 cursor-pointer md:w-8 md:h-8">
          <AvatarImage
            :src="data?.user?.image || 'https://github.com/unovue.png'"
            alt="@unovue"
          />
          <AvatarFallback>CN</AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent class="w-40 md:w-32">
        <DropdownMenuItem class="text-sm md:text-sm">
          <a href="mailto:hey@make.email">{{ $t("common.support") }}</a>
        </DropdownMenuItem>
        <DropdownMenuItem
          class="text-sm md:text-sm"
          @click="handleOpenFeedbackModal"
        >
          <span>{{ $t("feedback.title") }}</span>
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem class="text-sm md:text-sm" @click="handleSignOut">
          <span>{{ $t("auth.logout") }}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
</template>

<script lang="ts" setup>
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import ProseSmall from "~/components/Typography/ProseSmall.vue";

const { status, signOut, data } = useAuth();
const loggedIn = computed(() => status.value === "authenticated");

const { openSignInModal, openFeedbackModal } = useModals();

async function handleSignOut() {
  await signOut();
}

const handleOpenFeedbackModal = () => {
  if (!loggedIn.value) {
    openSignInModal();
    return;
  }

  openFeedbackModal();
};
</script>
